import React, { useState } from "react";
import { Redirect, Link } from "react-router-dom";
import { Plugins, registerWebPlugin } from "@capacitor/core";
import { FacebookLogin as FacebookLoginPlugin } from "@rdlabo/capacitor-facebook-login";

import {
  IonContent,
  IonPage,
  IonButton,
  IonItem,
  IonLabel,
  IonInput,
  IonIcon,
  IonText,
  IonToast,
} from "@ionic/react";

import { logoFacebook } from "ionicons/icons";
import "./style.css";

import { injectContext, AppProps } from "../../base/AppContext";
import VisibilityOffIcon from "../../assets/icons/VisibilityOffIcon.svg";
import VisibilityIcon from "../../assets/icons/VisibilityIcon.svg";

import { ButtonLoading } from "../../components/Ui/ButtonLoading";

import { useChange } from "../../hooks/useChange";

import { SignInForm } from "../../interfaces/auth";

import { useSignIn } from "../../hooks/useSignIn";

import IconBackground from "../../assets/icons/icon-background.png";

const FACEBOOK_PERMISSIONS = [
  "email",
  "public_profile",
  // "user_birthday",
  // "user_photos",
];

declare global {
  interface Window {
    FB: any;
  }
}

const app =
  !document.URL.startsWith("http") ||
  document.URL.startsWith("http://localhost:8080");

let { FacebookLogin } = Plugins;

if (!app) {
  registerWebPlugin(FacebookLoginPlugin as any);
  window.fbAsyncInit = function () {
    if (window.FB) {
      window.FB.init({
        appId: "647577739370172",
        autoLogAppEvents: true,
        cookie: true,
        xfbml: true,
        version: "v2.10",
      });
    }
  };

  // Load the SDK asynchronously
  (function (d) {
    var js,
      id = "facebook-jssdk",
      ref = d.getElementsByTagName("script")[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement("script");
    js.id = id;
    js.async = true;
    js.src = "https://connect.facebook.net/en_US/all.js";
    if (ref.parentNode) {
      ref.parentNode.insertBefore(js, ref);
    }
  })(document);
}

const SignInPage: React.FC<AppProps> = ({ login, isAuth, isWelCome }) => {
  const [showPass, setShowPass] = useState<boolean>(false);
  const [state, setState] = useState<{ form: SignInForm }>({
    form: {
      username: "",
      password: "",
    },
  });

  const { onIonChange } = useChange({ setState });

  const onLoginSuccess = (res: any) => {
    login(res.token_id);
  };

  const {
    onLogin,
    loading,
    onSignInFacebook,
    userNoMatch,
    cancelUserNoMatch,
  } = useSignIn(state.form, onLoginSuccess);

  const onLoginFacebook = async () => {
    const result = await FacebookLogin.login({
      permissions: FACEBOOK_PERMISSIONS,
    });
    if (result.accessToken) {
      // Login successful.
      await onSignInFacebook(result.accessToken.token);
    }
  };

  if (isAuth) {
    if (!isWelCome) {
      return <Redirect to="/page/welcome" />;
    }
    return <Redirect to="/page/passages" />;
  }

  return (
    <IonPage>
      <IonContent className="background-content">
        <IonToast
          isOpen={userNoMatch}
          position="bottom"
          message="Usuário ou senha inválido"
          duration={3000}
          onDidDismiss={() => cancelUserNoMatch()}
          buttons={[
            { text: "Ok", role: "cancel", handler: () => cancelUserNoMatch() },
          ]}
        />

        <div className="sign-in-page">
          <div className="sign-in-page-panel">
            <div className="sign-in-panel-form">
              <div className="sign-in-panel-form-title">
                <img
                  style={{ height: 185 }}
                  src={IconBackground}
                  alt="Logo PassageVan"
                />
                {/* <h2>Login</h2> */}
              </div>
              <div className="sign-in-panel-form-content">
                <IonItem>
                  <IonLabel position="floating">E-mail ou Telefone</IonLabel>
                  <IonInput
                    onIonChange={onIonChange}
                    name="username"
                    value={state.form.username}
                    type="text"
                  />
                </IonItem>
                <IonItem>
                  <IonLabel position="floating">senha</IonLabel>
                  <IonInput
                    type={showPass ? "text" : "password"}
                    name="password"
                    value={state.form.password}
                    onIonChange={onIonChange}
                  />
                  <IonButton
                    className="button-visible-pass"
                    onClick={() => setShowPass(!showPass)}
                    slot="end"
                  >
                    <IonIcon
                      slot="icon-only"
                      icon={showPass ? VisibilityIcon : VisibilityOffIcon}
                    />
                  </IonButton>
                </IonItem>
              </div>
              <div className="sign-in-panel-form-footer">
                <ButtonLoading
                  loading={loading}
                  onClick={onLogin}
                  disabled={
                    state.form.username === "" || state.form.password === ""
                  }
                  text="Entrar"
                />
              </div>
            </div>
            <div className="sign-up-panel">
              <IonButton className="facebook" onClick={onLoginFacebook}>
                <IonIcon className="facebook-icon" icon={logoFacebook} />
                Facebook
              </IonButton>
              <div className="line-separet">
                <hr style={{ background: "rgba(208, 203, 205, 0.28)" }} />
                <div className="line-text">
                  <IonText>Ou</IonText>
                </div>
              </div>
              <Link to="/sign-up" style={{ marginBottom: "1.5rem" }}>
                <IonButton>Cadastre-se</IonButton>
              </Link>

              <Link
                to="/recover"
                style={{
                  textAlign: "center",
                  width: 200,
                  padding: "10px 0px",
                }}
              >
                <IonText style={{ color: "#fff", fontSize: ".9rem" }}>
                  Esqueceu sua senha ?
                </IonText>
              </Link>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default injectContext(SignInPage);
